export default "__VITE_ASSET__DUeC6mO7__"